// extracted by mini-css-extract-plugin
module.exports = {"nav":"style_nav__iunWX","navList":"style_navList__SN2F1","navListItem":"style_navListItem__nPO8P","tabLink":"style_tabLink__d2Syo","dropdownMenu":"style_dropdownMenu__rL3lL"};